import axios, { AxiosError, AxiosInstance } from 'axios';

import ErrorResponse from './types/ErrorResponse';

import errorResponseNotification from '../helpers/errorResponseNotification';

import { config } from 'config/config';

const apiClient = axios.create({
	baseURL: config.apiUrl,
	withCredentials: true,
	withXSRFToken: true,
});

apiClient.interceptors.response.use(
	(response): any => {
		return response.data;
	},
	(error: AxiosError<any>) => {
		const response: ErrorResponse = {
			errors: error?.response?.data.errors ?? [],
		};

		if (error.request.statusText !== 'Unauthorized') {
			errorResponseNotification(response);
		}

		return Promise.reject(response);
	},
);

export const fetchScrf = (onSuccess: () => void, onError: (error: AxiosError) => void) => {
	apiClient.get('/csrf').then(onSuccess).catch(onError);
};

class ApiClient {
	client: AxiosInstance;

	constructor() {
		this.client = apiClient;
	}
}

export default ApiClient;
